import { render, staticRenderFns } from "./TableNumbers.vue?vue&type=template&id=34673ced"
import script from "./TableNumbers.vue?vue&type=script&lang=js"
export * from "./TableNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports